module.exports = __webpack_public_path__ + "img/20.f10baf30.png";